/** * 语言选择 * @author ryan bian */
<template>
  <div
    :class="{
      [$style.LanguagePicker__Wrapper]: true,
      [$style['LanguagePicker__Wrapper--light']]: isDayMode,
    }"
  >
    <div :class="$style.LanguagePicker__Content" @mouseenter="open = true" @mouseleave="handleMouseLeave">
      <slot>{{ curLanguageInfo.name }}</slot>
      <!-- <i
        :class="{
          ['el-icon-arrow-down']: !open,
          ['el-icon-arrow-up']: open,
        }"
      /> -->
      <r-icon name="icon-zhankai" />
    </div>
    <transition name="fade-bottom" @after-enter="afterEnter">
      <ul
        :class="$style.LanguagePicker__List"
        :style="popupStyle"
        v-if="open"
        tabindex="-1"
        @mouseleave="open = false"
        @mouseenter="handleMouseEnterPopover"
      >
        <li @click="setLocale(config.locale)" v-for="config in languageList" :key="config.id">
          <SensorTrack
            :datas="{
              sensorEventName: $sensor.SENSOR_EVENT_NAME.CLICK_TOP_BAR,
              module_name: '选择语言',
              button_name: config.name,
            }"
            :class="{
              [$style.LanguagePicker__Item]: true,
              [$style['LanguagePicker__Item--active']]: config.locale === curLanguageInfo.locale,
            }"
          >
            <!-- <span :class="$style.LanguagePicker__Flag">{{ config.flag }}</span> -->
            {{ config.name }}
          </SensorTrack>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import get from 'lodash-es/get';
import { mapState } from '~/common/js/patch';
import { getBrowserLang, switchLanguage } from '~/common/js/utils';
import { LOCALES, OLD_LOCALES_OBJ, OLD_LOCALES_OBJ_REVERSE } from '~/common/js/const';
// import { countryNameMap } from '~/common/js/country-name'

// 语言配置
// const OPTIONAL_LOCALES = ['cn', 'jp', 'vn', 'ru', 'cn_tw', 'tr', 'es', 'br']

export default {
  name: 'LanguagePicker',
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      isDayMode: (state) => state.isDayMode,
      languageList: (state) =>
        state.localeConfigList.map((item) => ({
          ...item,
          // flag: countryNameMap[item.locale.split('-')?.[1]]?.flag || '',
        })),
      curLanguageInfo: (state) => {
        const upcaseLocale = OLD_LOCALES_OBJ_REVERSE[state.locale] || state.locale;
        return {
          ...state.localeConfigList.find((item) => item.locale === upcaseLocale),
          // flag: countryNameMap[upcaseLocale.split('-')?.[1]]?.flag || '',
        };
      },
    }),
    popupStyle() {
      const style = {};
      if (this.align === 'left') {
        Object.assign(style, {
          left: 0,
        });
      } else {
        Object.assign(style, {
          right: 0,
        });
      }
      return style;
    },
  },
  data() {
    return {
      open: false,
      // languageList: LANGUAGE_CONFIG,
    };
  },
  props: {
    align: {
      validator(value) {
        return ['left', 'right'].includes(value);
      },
      default: 'left',
    },
  },
  methods: {
    setLocale(lang) {
      const finalLang = OLD_LOCALES_OBJ[lang] || lang;
      this.open = false;
      switchLanguage(finalLang, this.$route, this.$router);
    },
    // toggle() {
    //   this.open = !this.open;
    // },
    afterEnter(el) {
      // el.focus();
    },
    handleMouseEnterPopover() {
      this._timer && clearTimeout(this._timer);
    },
    handleMouseLeave() {
      this._timer && clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.open = false;
      }, 400);
    },
  },
  mounted() {
    const paramLang = get(this.$route, ['params', 'lang']);

    // 如果路径后面没跟/cn /jp 之类 则do noting
    if (paramLang) {
      return;
    }

    const targetLang = Cookies.get('golang') || localStorage.getItem('golang') || getBrowserLang();
    const routeParam = {
      query: this.$route.query,
      params: { lang: targetLang },
    };

    if (LOCALES.includes(targetLang)) {
      if (this.$route.path === '/' && !this.$route.query.r) {
        this.$router.push(`/${targetLang}`);
      } else {
        this.$router.push(routeParam);
      }
    }
  },
};
</script>

<style lang="less" module>
@import '../../common/css/element-base-type.less';

.LanguagePicker {
  &__Wrapper {
    position: relative;
    &--light {
      // 浅色版本
    }
  }
  &__Content {
    cursor: pointer;
    white-space: nowrap;
    display: block;
    height: @head_height;
    line-height: @head_height;
    transition: color 0.5s ease;
    &:hover {
      color: @blue-base;
    }
  }
  &__List {
    position: absolute;
    top: @head_height;
    width: 160px;
    padding: 22px 26px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: @boxShadowBig;
    font-size: 14px;
    &:focus {
      outline: 0 none;
    }
  }
  &__Item {
    display: flex;
    height: 42px;
    align-items: center;
    color: @color-primary-def;
    white-space: nowrap;
    cursor: pointer;
    &--active {
    }
    transition: color 0.5s ease;
    &:hover {
      color: @blue-base;
    }
  }
  &__Flag {
    margin-right: 12px;
  }
}
</style>
